<!--
 * @Author: zhaoyang
 * @Date: 2020-10-21 17:53:57
 * @LastEditors: your name
 * @LastEditTime: 2020-10-21 17:53:57
 * @Description: c端退款
-->

<template>
  <div>
    <div v-if="dialogloading" class="loading-line">
      <p>
        <i class="el-icon-loading" />
      </p>
    </div>
    <div v-else class="refound-detail-page">
      <RefoundStatus
        class="refound-page-header"
        :refoundInfo="refoundInfo"
      ></RefoundStatus>
      <RefoundDetail
        class="detail-info"
        :refoundInfo="refoundInfo"
      ></RefoundDetail>
    </div>
  </div>
</template>
<script>
import RefoundDetail from '@/components/Order/corder-refound-detail';
import RefoundStatus from '@/components/Order/corder-refound-status';
export default {
  props: {
    dialogloading: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    refoundInfo: {
      type: Object,
      default: () => {
        return {
          orderDto: {
            status: '',
          },
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  components: {
    RefoundDetail,
    RefoundStatus,
  },
};
</script>
<style lang="scss" scoped>
.loading-line {
  height: 40px;
  margin: 30px auto 0;

  p {
    @include flex();
    height: 40px;
  }

  i {
    font-size: 1.6em;
  }
}
.refound-detail-page {
  height: auto;
}
.refound-title {
  border-bottom: 1px solid #dddddd;
}
.refound-page-header {
  padding: 0 18px;
  position: relative;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
  background: #ffffff;
}
.success-icon {
  margin-right: 8px;
  font-size: 24px;
  vertical-align: middle;
  color: #3dbc2a;
}
.detail-info {
  padding-bottom: 16px;
  margin-top: 20px;
  border-radius: 4px;
  background: #ffffff;
}
.coutinue-refound {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  padding: 0 20px;
  border-radius: 36px;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  background: #fed838;
  color: #222c43;
}
</style>
